import type {
  PaabudDetailModel,
  PaabudIndberetningOverviewModel,
} from "@/interfaces/paabud";
import { get, getBlob, getWithErrorObject } from "./util";

const PAABUD_QUERY = "Paabud";

export const PAABUD_QUERY_KEY = ["paabud"] as const;

export const createPaabudDetailQueryKey = (id: string) =>
  [...PAABUD_QUERY_KEY, "detail", id] as const;

export const getAllPaabudIndberetninger = (): Promise<
  PaabudIndberetningOverviewModel[]
> =>
  get<PaabudIndberetningOverviewModel[]>({
    query: `${PAABUD_QUERY}/HentAllePaabudIndberetninger`,
  });

export const getPaabud = (id: string): Promise<PaabudDetailModel> =>
  getWithErrorObject<PaabudDetailModel>({
    query: `${PAABUD_QUERY}/HentPaabud/${id}`,
  });

export const fetchPaabudDocumentFile = (id: string): Promise<Blob> =>
  getBlob({
    query: `${PAABUD_QUERY}/HentPaabud/${id}/download`,
  });
